export default __webpack_public_path__ + "static/media/kefu.60fe40d7.png";